// Pure mappers for the alkanode REST responses we read (get-alkanes-utxo and
// get-address-utxos), extracted from the hooks so the parsing is unit-testable
// without pulling in react-query / lasereyes.

// get-alkanes-utxo `data[]` -> outpoints in the shape consumers expect.
// Each item: { txId, outputIndex, satoshis, alkanes: { "block:tx": {name,symbol,value} | "value" } }.
// Keeps only alkane-bearing outpoints. The alkane amount lives in `value` (the map
// value is an object on current responses, or a bare string on older ones).
export function mapAlkaneUtxos(items) {
  return (Array.isArray(items) ? items : [])
    .filter(it => it && it.alkanes && Object.keys(it.alkanes).length > 0)
    .map(it => {
      const balances = Object.entries(it.alkanes).map(([id, v]) => {
        const [block, tx] = id.split(':');
        const amount = (v && typeof v === 'object') ? v.value : v;
        return { block: parseInt(block, 10), tx: parseInt(tx, 10), amount: Number(amount) };
      });
      return {
        outpoint: { txid: it.txId, vout: it.outputIndex },
        output: { value: it.satoshis ?? 0 },
        balance_sheet: { cached: { balances } },
        // espo reports confirmations, not block height; height is unused downstream
        height: null,
      };
    });
}

// get-address-utxos `data` -> { confirmed, unconfirmed } in spendable BTC sats.
// spendableTotalBalance excludes alkane/inscription UTXOs (what's usable for fees);
// pendingTotalBalance is the unconfirmed delta.
export function mapAddressBalance(data) {
  const d = data || {};
  return {
    confirmed: d.spendableTotalBalance ?? 0,
    unconfirmed: d.pendingTotalBalance ?? 0,
  };
}
